import { createReducer } from '@reduxjs/toolkit';
import AvailabilityReducer from './availability_reducer';
import BookingReducer from './booking_reducer';
import CheckoutReducer from './checkout_reducer';
import ExperienceReducer from './experience_reducer';
import ResourcesReducer from './resources_reducer';
import ServicesReducer from './services_reducer';
import TypesReducer from './types_reducer';
import UIReducer from './ui';
import UserReducer from './user_reducer/user_reducer';
import VehicleLinkReducer from './vehicle_link_reducer';

const { redux_initial_state: initialState } = window.ecom;
const reducers = {
  booking: BookingReducer,
  types: TypesReducer,
  resources: ResourcesReducer,
  user: UserReducer,
  availability: AvailabilityReducer,
  vehicleLink: VehicleLinkReducer,
  product_page_id: createReducer(initialState.product_page_id, {}),
  checkout: CheckoutReducer,
  countries: createReducer(initialState.countries || {}, {}),
  regions: createReducer(initialState.regions || {}, {}),
  locations: createReducer(initialState.locations || {}, {}),
  ui: UIReducer,
  jackson: createReducer(initialState.jackson || {}, {}),
  services: ServicesReducer,
  sealink: createReducer(initialState.sealink || {}, {}),
  routes: createReducer(initialState.routes || {}, {}),
  experience: ExperienceReducer,
};

export default reducers;
